<template>
    <div>
        <b-modal hide-footer header-text-variant="true" id="modal-redConceptos" size="lg">
            <div class="d-xl-block d-lg-block d-none">
              <img src="recursos/img/U2_INLIN_004_modal.png" class="img-fluid mx-auto d-flex" alt="">
            </div>
            <div class="d-xl-none d-lg-none d-block">
              <img src="recursos/img/U2_INLIN_004_modal_cel.png" class="img-fluid mx-auto d-flex" alt="">
            </div>
       </b-modal>
    </div>
</template>

<script>
export default {
    name: 'Modales'
}
</script>